import {useTranslation} from 'react-i18next';
import {Card} from 'primereact/card';
import {useForm} from 'react-hook-form';
import {InputText} from 'primereact/inputtext';
import {MultiSelect} from 'primereact/multiselect';
import {Button} from 'primereact/button';
import Breadcrumbs from '../../components/Breadcrumbs/Breadcrumbs.jsx';
import {useUnit} from 'effector-react';
import {$user, updateMyProfileEv, updateMyProfileFx} from '../../models/authModel/index.js';

export default function MyProfile() {
    const {t} = useTranslation()
    const user = useUnit($user)
    const loading = useUnit(updateMyProfileFx.pending)
    const submit = useUnit(updateMyProfileEv)

    const {
        register,
        handleSubmit,
        reset
    } = useForm({
        values: {
            username: user?.name ?? '',
            organization: '',
            location: [],
            govId: user?.gov_id ?? '',
            oked: '',
            position: '',
            email: user?.email ?? '',
            phone: '',
            address: ''
        }
    })

    const onSubmit = (data) => {
        const filtered = {}
        for (const [key, value] of Object.entries(data)) {
            if (value === '' || !value || key === 'location') {
                continue
            } else {
                const keyMap = {
                    govId: 'gov_id',
                    username: 'name'
                }
                if (value !== user[(keyMap[key] ?? key)]) {
                    filtered[key] = value
                }
            }
        }
        submit(filtered)
    }

    return <div className={'flex flex-column gap-3 w-full h-full align-items-center'}>
        <Breadcrumbs />
        <Card title={t('Персональные данные')}
              subTitle={t('Здесь вы можете изменить ваши персональные данные')}
              className={'shadow-1'}
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <div className={'formgrid grid'}>
                    <div className={'field col-6'}>
                        <label htmlFor={'username'} className={'font-bold block'}>{t('Имя пользователя')}</label>
                        <InputText id={'username'} {...register('username')} className={'w-full'} />
                    </div>
                    <div className={'field col-6'}>
                        <label htmlFor={'organization'} className={'font-bold block'}>{t('Название организации')}</label>
                        <InputText id={'organization'} {...register('organization')} className={'w-full'}/>
                    </div>
                    <div className={'field col-6'}>
                        <label htmlFor={'location'} className={'font-bold block z-1'}>{t('Местонахождение')}</label>
                        <MultiSelect inputId={'location'} maxSelectedLabels={1} showClear {...register('location')} className={'w-full'}/>
                    </div>
                    <div className={'field col-6'}>
                        <label htmlFor={'govId'} className={'font-bold block'}>{t('ИИН/БИН')}</label>
                        <InputText id={'govId'} {...register('govId')} maxLength={12} className={'w-full'}/>
                    </div>
                    <div className={'field col-6'}>
                        <label htmlFor={'oked'} className={'font-bold block'}>{t('ОКЭД')}</label>
                        <InputText id={'oked'} {...register('oked')} className={'w-full'}/>
                    </div>
                    <div className={'field col-6'}>
                        <label htmlFor={'position'} className={'font-bold block'}>{t('Должность')}</label>
                        <InputText id={'position'} {...register('position')} className={'w-full'}/>
                    </div>
                    <div className={'field col-6'}>
                        <label htmlFor={'email'} className={'font-bold block'}>{t('Электронная почта')}</label>
                        <InputText id={'email'} {...register('email')} className={'w-full'}/>
                    </div>
                    <div className={'field col-6'}>
                        <label htmlFor={'phone'} className={'font-bold block'}>{t('Телефон')}</label>
                        <InputText id={'phone'} {...register('phone')} className={'w-full'}/>
                    </div>
                    <div className={'field col-12'}>
                        <label htmlFor={'address'} className={'font-bold block'}>{t('Адрес организации')}</label>
                        <InputText id={'address'} {...register('address')} className={'w-full'}/>
                    </div>
                    <div className={'col-12 flex justify-content-end gap-2'}>
                        <Button type={'submit'} label={'Сохранить'} loading={loading}/>
                        <Button label={'Отменить'} outlined severity={'warning'} loading={loading} onClick={() => reset()}/>
                    </div>
                </div>
            </form>
        </Card>
    </div>
}